import type { ErrorMessageMode } from '/#/axios';
import { useMessage } from '/@/hooks/web/useMessage';
import { useI18n } from '/@/hooks/web/useI18n';
import { useUserStoreWithOut } from '/@/store/modules/user';
import projectSetting from '/@/settings/projectSetting';
import { message } from 'ant-design-vue';
import { router } from '/@/router';

const { createMessage, createErrorModal } = useMessage();
const error = createMessage.error!;
const stp = projectSetting.sessionTimeoutProcessing;

export function checkStatus(
  status: number,
  code: number | string,
  msg: string,
  errorMessageMode: ErrorMessageMode = 'message',
  isTimeout = false
): void {
  if (isTimeout) {
    message.error('请求超时');
    return;
  }
  const { t } = useI18n();
  const userStore = useUserStoreWithOut();
  let errMessage = '';
  switch (status) {
    case 400:
      if (code === '600001') {
        // @ts-ignore
        message.error(() => (
          <>
            {msg}，
            <span
              style={{
                color: 'rgba(209, 108, 68, 1)',
                textDecorationLine: 'underline',
                cursor: 'pointer',
              }}
              onClick={async () => {
                const { openPayModal } = await import('/@/utils/payment');
                openPayModal();
              }}
            >
              开通套餐
            </span>
            解除限制
          </>
        ));
      } else {
        errMessage = `${msg}`;
      }

      break;
    // 401: Not logged in
    // Jump to the login page if not logged in, and carry the path of the current page
    // Return to the current page after successful login. This step needs to be operated on the login page.
    case 401:
      // 抢登
      if (code === '4011') {
        userStore.logoutByOverridden();
      }
      // 访问了不存在的组织
      else if (code === '4012') {
        userStore.selectOrg({
          isUseRecent: true,
          okText: '切换到其他组织',
          content: '您访问的组织不存在。',
        });
      } else {
        errMessage = msg || t('sys.api.errMsg401');
        userStore.goLogin();
      }
      break;
    case 403:
      errMessage = msg || '没有权限';
      break;
    // 404请求不存在
    case 404:
      errMessage = t('sys.api.errMsg404');
      break;
    case 405:
      errMessage = t('sys.api.errMsg405');
      break;
    case 408:
      errMessage = t('sys.api.errMsg408');
      break;
    case 500:
      errMessage = t('sys.api.errMsg500');
      break;
    case 501:
      errMessage = t('sys.api.errMsg501');
      break;
    case 502:
      errMessage = t('sys.api.errMsg502');
      break;
    case 503:
      errMessage = t('sys.api.errMsg503');
      break;
    case 504:
      errMessage = t('sys.api.errMsg504');
      break;
    case 505:
      errMessage = t('sys.api.errMsg505');
      break;
    default:
  }

  if (errMessage) {
    if (errorMessageMode === 'modal') {
      createErrorModal({ title: t('sys.api.errorTip'), content: errMessage });
    } else if (errorMessageMode === 'message') {
      error({ content: errMessage, key: `global_error_message_status_${status}` });
    }
  }
}
